document.querySelectorAll("[data-faq-tabs]").forEach(function (section) {
  if (section.dataset.faqTabsReady) return;
  section.dataset.faqTabsReady = "true";

  var tabs = section.querySelectorAll("[data-faq-tab]");
  var panels = section.querySelectorAll("[data-faq-panel]");
  var questions = section.querySelectorAll(".accordion-question");

  tabs.forEach(function (tab) {
    tab.addEventListener("click", function () {
      var index = tab.getAttribute("data-faq-tab");

      tabs.forEach(function (item) {
        var isActive = item.getAttribute("data-faq-tab") === index;
        item.classList.toggle("faq-tabs__tab--active", isActive);
        item.setAttribute("aria-selected", isActive ? "true" : "false");
      });

      panels.forEach(function (panel) {
        var isActive = panel.getAttribute("data-faq-panel") === index;
        panel.classList.toggle("faq-tabs__panel--active", isActive);
        panel.hidden = !isActive;
      });
    });
  });

  questions.forEach(function (element) {
    element.addEventListener("click", function () {
      var parent = element.closest(".accordion-block-faq");
      if (!parent) return;

      questions.forEach(function (item) {
        var itemParent = item.closest(".accordion-block-faq");
        if (itemParent && itemParent !== parent) {
          itemParent.classList.remove("active");
        }
      });

      parent.classList.toggle("active");
    });
  });
});
